export const domRemoveStoreResults = storeContainer => {
  const containerParent = storeContainer.parentNode;
  if (containerParent.$$('.js-store-result'))
    containerParent.$$('.js-store-result').forEach(e => e.remove());
};



// WEBPACK FOOTER //
// ./src/catalog/product-details/pdp-store_selection-utils.js